import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-24e5032e")

_pushScopeId("data-v-24e5032e")
const _hoisted_1 = { class: "talent-container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "office-info" }, [
  /*#__PURE__*/_createVNode("h3", { class: "txt office-headline" }, "ひまわりがonlyliveに登場！"),
  /*#__PURE__*/_createVNode("p", { class: "txt office-info-text" }, [
    /*#__PURE__*/_createTextVNode("ひまわりとあなただけの、二人きりのオンライン通話ができるようになりました！"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("あなただけの特別な時間をお届けいたします！")
  ])
], -1)
const _hoisted_3 = { class: "contents-talent" }
const _hoisted_4 = { class: "txt txt txt-medium name" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BaseRoundRectButton = _resolveComponent("BaseRoundRectButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("img", {
        class: "talent-card talent-box",
        src: _ctx.state.imageSrc
      }, null, 8, ["src"]),
      _createVNode("p", _hoisted_4, _toDisplayString(_ctx.state.message), 1),
      _createVNode("a", {
        class: "talent-button",
        href: _ctx.state.url
      }, [
        _createVNode(_component_BaseRoundRectButton, {
          class: "btn",
          text: "スケジュールを確認"
        })
      ], 8, ["href"])
    ])
  ]))
})